import { useState } from 'react'

const contentBlock = {
  display: 'flex',
  flexDirection: 'column',
  gap: 12
}

const titleRow = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'wrap'
}

const donutWrap = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 0'
}

const donut = {
  width: 220,
  height: 220,
  borderRadius: '50%',
  position: 'relative'
}

const donutCenter = {
  position: 'absolute',
  inset: 30,
  background: '#fff',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  fontWeight: 700,
  color: '#0d5f53'
}

const card = {
  padding: 8,
  border: '1px solid #d4d4d4',
  borderRadius: 8,
  background: '#fff',
  fontSize: 16
}

const COLORS = ['#4F81BD', '#6FA16F', '#C27C59', '#9B6FAE', '#BFA65A']

const StatsEmissionsModal = ({ stats, t, fmtNum, filterCriteria = {} }) => {
  const [tooltip, setTooltip] = useState(null)
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 })

  const selectedVehicleId =
    filterCriteria?.vehicleId ??
    filterCriteria?.vozidlo_id ??
    filterCriteria?.carId ??
    filterCriteria?.vehicle ??
    ''

  const allData = stats.emissionData || []

  const data = selectedVehicleId
    ? allData.filter(item => String(item.vehicleId) === String(selectedVehicleId))
    : allData

  const total = data.reduce((sum, item) => sum + Number(item.totalEmissionKg || 0), 0)

  const filteredLegend = selectedVehicleId
    ? (stats.tripsLegend || []).filter(v => String(v.vehicleId) === String(selectedVehicleId))
    : (stats.tripsLegend || [])

  const vehicleMap = filteredLegend.reduce((acc, v) => {
    acc[String(v.vehicleId)] = v
    return acc
  }, {})

  const getPlate = (item) => {
    const v = vehicleMap[String(item.vehicleId)]
    return (
      v?.licensePlate ||
      v?.spz ||
      item?.licensePlate ||
      item?.spz ||
      ''
    )
  }

  const selectedVehicle = selectedVehicleId
    ? allData.find(v => String(v.vehicleId) === String(selectedVehicleId))
    : null

  const vehicleText = selectedVehicle
    ? `${selectedVehicle.name || ''}${(selectedVehicle.licensePlate || selectedVehicle.spz) ? ` (${selectedVehicle.licensePlate || selectedVehicle.spz})` : ''}`
    : t('TRIPLOG.STATISTICS.ALL_VEHICLES', { defaultValue: 'všetky vozidlá' })

  let cumulative = 0
  const gradient = data.length
    ? `conic-gradient(${data.map((item, index) => {
        const share = total > 0 ? (Number(item.totalEmissionKg || 0) / total) * 100 : 0
        const start = cumulative
        cumulative += share
        return `${COLORS[index % COLORS.length]} ${start}% ${cumulative}%`
      }).join(', ')})`
    : '#e6e6e6'

  return (
    <>
      <div style={contentBlock}>
<div style={titleRow}>
  <h4 style={{ margin: 0 }}>
    {t('TRIPLOG.STATISTICS.CO2.CO2_TOTAL', { defaultValue: 'Emisie CO₂' })}
  </h4>
  <span style={{ color: '#107c6b', fontWeight: 700 }}>
    {stats.tripsPeriodText}
  </span>
</div>

<div style={titleRow}>
  <h4 style={{ margin: 0 }}>
    {t('TRIPLOG.STATISTICS.SHOWN_VEHICLE')}
  </h4>
  <span style={{ color: '#107c6b', fontWeight: 700 }}>
    {vehicleText}
  </span>
</div>

        <div style={donutWrap}>
          <div
            style={{ ...donut, background: gradient }}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect()

              const cx = rect.left + rect.width / 2
              const cy = rect.top + rect.height / 2

              const dx = e.clientX - cx
              const dy = e.clientY - cy

              let angle = Math.atan2(dy, dx) * (180 / Math.PI)
              angle = angle < 0 ? angle + 360 : angle
              angle = (angle + 90) % 360

              let cumulativeAngle = 0

              for (let i = 0; i < data.length; i++) {
                const item = data[i]
                const value = Number(item.totalEmissionKg || 0)
                const share = total > 0 ? (value / total) * 360 : 0

                if (angle >= cumulativeAngle && angle <= cumulativeAngle + share) {
                  const plateVal = getPlate(item)

                  setTooltip(
                    `${item.name}${plateVal ? ` (${plateVal})` : ''} • ${fmtNum(value, 2)} ${t('TRIPLOG.UNITS.KG')}`
                  )

                  setCursorPos({ x: e.clientX, y: e.clientY })
                  return
                }

                cumulativeAngle += share
              }

              setTooltip(null)
            }}
            onMouseLeave={() => setTooltip(null)}
          >
            <div style={donutCenter}>
              {fmtNum(total, 2)} {t('TRIPLOG.UNITS.KG')}
            </div>
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: 8
          }}
        >
          {data.map((item, index) => {
            const share =
              total > 0
                ? (Number(item.totalEmissionKg || 0) / total) * 100
                : 0

            const plateVal = getPlate(item)

            return (
              <div key={item.id || index} style={card}>
                <div
                  style={{
                    color: COLORS[index % COLORS.length],
                    fontWeight: 700,
                    marginBottom: 6
                  }}
                >
                  {item.name}{plateVal ? ` (${plateVal})` : ''}
                </div>

                <div>
                  {t('TRIPLOG.STATISTICS.CO2.CO2_KM')}: {fmtNum(item.totalKm, 2)} {t('TRIPLOG.UNITS.KM')}
                </div>

                <div>
                  {t('TRIPLOG.STATISTICS.CO2.CO2_PER_KM')}: {fmtNum(item.emissionsPerKm, 2)} {t('TRIPLOG.UNITS.G_PER_KM')}
                </div>

                <div>
                  {t('TRIPLOG.STATISTICS.CO2.TOTAL_CO2')}: {fmtNum(item.totalEmissionKg, 2)} {t('TRIPLOG.UNITS.KG')}
                </div>

                <div>
                  {t('TRIPLOG.STATISTICS.CO2.CO2_SHARE')}: {share.toFixed(2)}%
                </div>
              </div>
            )
          })}
        </div>
      </div>

      {tooltip && (
        <div
          style={{
            position: 'fixed',
            top: cursorPos.y - 50,
            left: cursorPos.x,
            transform: 'translateX(-50%)',
            background: 'rgba(0,0,0,0.85)',
            color: '#E7DFEC',
            padding: '5px 12px',
            borderRadius: 10,
            fontSize: 14,
            pointerEvents: 'none',
            zIndex: 5000
          }}
        >
          {tooltip}
        </div>
      )}
    </>
  )
}

export default StatsEmissionsModal